// Adapted from Magic UI Grid Pattern (MIT), discovered through 21st.dev.
// https://21st.dev/@dillionverma/components/grid-pattern
// https://magicui.design/r/grid-pattern.json
import { useId, type SVGProps } from 'react';
export function GridPattern({width=26,height=26,x=-1,y=-1,className='',...props}:SVGProps<SVGSVGElement>&{width?:number;height?:number;x?:number;y?:number}){
 const id=useId();
 return <svg aria-hidden="true" className={`terminal-grid-pattern ${className}`} {...props}><defs><pattern id={id} width={width} height={height} patternUnits="userSpaceOnUse" x={x} y={y}><path d={`M.5 ${height}V.5H${width}`} fill="none"/></pattern></defs><rect width="100%" height="100%" strokeWidth={0} fill={`url(#${id})`}/></svg>;
}
